export default __webpack_public_path__ + "static/media/recipalooza_screenshot.6724d6ef.png";